import { render, staticRenderFns } from "./mask.vue?vue&type=template&id=327be300&scoped=true&"
var script = {}
import style0 from "./mask.vue?vue&type=style&index=0&id=327be300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327be300",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/mask.vue
// module id = null
// module chunks = 